import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerAuthService } from './auth.service';

/**
 * Guards customer-only routes (my-account, checkout, delivery-address). When not signed in,
 * redirects to /login carrying a `returnUrl` so the login page can bounce back after sign-in.
 */
export const customerAuthGuard: CanActivateFn = (_route, state) => {
  const auth = inject(CustomerAuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
